import { FaPlay } from "react-icons/fa";

const LearningModuleItem = ({ index, title, duration, progress }) => {
  return (
    <div className="d-flex align-items-center p-3 mb-3 bg-dark rounded hover-card">
      {/* Number Circle */}
      <div
        className="d-flex align-items-center justify-content-center bg-primary rounded-circle me-3"
        style={{ width: "40px", height: "40px" }}
      >
        <span className="text-white fw-bold">{index}</span>
      </div>

      {/* Title & Duration */}
      <div className="flex-grow-1">
        <h6 className="text-light mb-1">{title}</h6>
        <small className="text-light">{duration}</small>
      </div>

      {/* Progress */}
      <div className="text-end">
        <div className="progress mb-2" style={{ width: "100px", height: "4px" }}>
          <div
            className="progress-bar bg-primary"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <small className="text-light">{progress}%</small>
      </div>

      {/* Play Button */}
      <button  className="btn btn-outline-primary btn-sm ms-3 d-flex align-items-center justify-content-center"
        style={{ width: "36px", height: "36px" }}>
        <FaPlay size={14} />
      </button>
    </div>
  );
};

export default LearningModuleItem;